import DashboardLayout from "./DashboardShell";
import { DASH } from "@/constants/testIds";
import {
  LayoutDashboard, BookOpenCheck, ClipboardCheck, NotebookPen,
  GraduationCap, Award, MessageSquare, Users, TrendingUp, FileText, Bell, Megaphone,
} from "lucide-react";
import { NotificationsInboxTab, AnnouncementsFeedTab } from "./manager/comms";
import { MessagesTab } from "./shared/messages";
import {
  TeacherOverviewTab, MyClassesTab, TeacherAttendanceTab, TeacherLessonTab,
  TeacherHomeworkTab, TeacherStudentsTab,
} from "./teacher/tabs";
import {
  ExamGradesTab, HomeworkGradingTab, ProgressReportsTab, StudentProgressTab,
} from "./teacher/progress";

export default function TeacherDashboard() {
  const tabs = [
    { key: "overview", label: "Today's Classes", icon: LayoutDashboard, render: () => <TeacherOverviewTab /> },
    { key: "classes", label: "My Classes", icon: BookOpenCheck, render: () => <MyClassesTab /> },
    { key: "students", label: "My Students", icon: Users, render: () => <TeacherStudentsTab /> },
    { key: "attendance", label: "Attendance", icon: ClipboardCheck, render: () => <TeacherAttendanceTab /> },
    { key: "lesson", label: "Today's Lessons", icon: NotebookPen, render: () => <TeacherLessonTab /> },
    { key: "homework", label: "Homework", icon: GraduationCap, render: () => <TeacherHomeworkTab /> },
    { key: "grading", label: "Homework Grading", icon: FileText, render: () => <HomeworkGradingTab /> },
    { key: "exams", label: "Exams & Grades", icon: Award, render: () => <ExamGradesTab /> },
    { key: "progress", label: "Student Progress", icon: TrendingUp, render: () => <StudentProgressTab /> },
    { key: "reports", label: "Progress Reports", icon: FileText, render: () => <ProgressReportsTab /> },
    { key: "notifications", label: "Notifications", icon: Bell, render: () => <NotificationsInboxTab /> },
    { key: "announcements", label: "Announcements", icon: Megaphone, render: () => <AnnouncementsFeedTab /> },
    { key: "messages", label: "Messages", icon: MessageSquare, render: () => <MessagesTab role="teacher" /> },
  ];
  return <DashboardLayout role="Teacher" testid={DASH.teacherRoot} tabs={tabs} />;
}
